import DialogActions from '@material-ui/core/DialogActions';
import PropTypes from 'prop-types';
import React from 'react';

import useStyles from './styles';

const ModalFooter = ({ children, className }) => {
  const classes = useStyles();
  return (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    <DialogActions classes={{ root: classes.footer }} className={className}>
      {children}
    </DialogActions>
  );
};

ModalFooter.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
};

export default ModalFooter;
